import * as React from "react"

const NotificationsContext = React.createContext(null)

const initialState = {
  notifications: [],
}

const NotificationsProvider = ({children}) => {
  const [state, setState] = React.useState(initialState)

  const value = {
    ...state,
    addError: error =>
      setState(oldState => ({
        ...oldState,
        notifications: [
          ...oldState.notifications,
          {type: "error", message: error},
        ],
      })),
    addInfo: info =>
      setState(oldState => ({
        ...oldState,
        notifications: [
          ...oldState.notifications,
          {type: "info", message: info},
        ],
      })),
    addSuccess: success =>
      setState(oldState => ({
        ...oldState,
        notifications: [
          ...oldState.notifications,
          {type: "success", message: success},
        ],
      })),
    removeNotification: notification =>
      setState(oldState => ({
        ...oldState,
        notifications: oldState.notifications.filter(
          notif => notif !== notification
        ),
      })),
  }
  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  )
}

const NotificationsConsumer = NotificationsContext.NotificationsConsumer

export default NotificationsContext
export {NotificationsConsumer, NotificationsProvider}
